import { createContext, useContext, useCallback } from 'react'
import toast from 'react-hot-toast'
import { setApiToast } from '../lib/api'

const ToastContext = createContext(null)

export function ToastProvider({ children }) {
  const success = useCallback((msg) => toast.success(msg), [])
  const error   = useCallback((msg) => toast.error(msg), [])
  const warning = useCallback((msg) => toast(msg, { icon: '⚠️' }), [])
  const info    = useCallback((msg) => toast(msg, { icon: 'ℹ️' }), [])
  const loading = useCallback((msg) => toast.loading(msg), [])
  const dismiss = useCallback((id) => toast.dismiss(id), [])

  // wire up to API interceptors
  setApiToast({ success, error, warning, info })

  return (
    <ToastContext.Provider value={{ success, error, warning, info, loading, dismiss }}>
      {children}
    </ToastContext.Provider>
  )
}

export function useToast() {
  const ctx = useContext(ToastContext)
  if (!ctx) throw new Error('useToast must be within ToastProvider')
  return ctx
}
